export default {
  tasks: null,
  task: null
};
